/* Rovela — interactive JS v11
   SAVE20 (20% off, qty 2+), SAVE30 (30% off, qty 3+)
   Auto-applied to checkout URL — no manual entry needed
*/
(function () {
  'use strict';

  function initFaq() {
    document.querySelectorAll('[data-rv-faq] .rv-faq__item').forEach(function (item) {
      var btn = item.querySelector('.rv-faq__q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.dataset.open === 'true';
        item.closest('[data-rv-faq]').querySelectorAll('.rv-faq__item').forEach(function (el) {
          el.dataset.open = 'false';
          var s = el.querySelector('.rv-faq__sign'); if (s) s.textContent = '+';
          var q = el.querySelector('.rv-faq__q'); if (q) q.setAttribute('aria-expanded','false');
        });
        if (!open) {
          item.dataset.open = 'true';
          btn.setAttribute('aria-expanded','true');
          var sign = item.querySelector('.rv-faq__sign'); if (sign) sign.textContent = '\u2212';
        }
      });
    });
  }

  function initSpecsTabs() {
    document.querySelectorAll('[data-rv-pdp]').forEach(function (section) {
      section.querySelectorAll('.rv-specs__tab').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tab = btn.dataset.tab;
          section.querySelectorAll('.rv-specs__tab').forEach(function (t) { t.dataset.active = t.dataset.tab === tab ? 'true' : 'false'; });
          section.querySelectorAll('.rv-specs__panel').forEach(function (p) { p.dataset.active = p.dataset.panel === tab ? 'true' : 'false'; });
        });
      });
    });
  }

  function initStickyBar() {
    var bar = document.querySelector('.rv-sticky-bar');
    var hero = document.querySelector('.rv-pdp-hero');
    if (!bar || !hero) return;
    new IntersectionObserver(function (e) { bar.dataset.visible = e[0].isIntersecting ? 'false' : 'true'; }, { threshold: 0 }).observe(hero);
  }

  function initGallery() {
    document.querySelectorAll('[data-rv-gallery]').forEach(function (gal) {
      var slides = gal.querySelectorAll('.rv-gallery__slide');
      var thumbs = gal.querySelectorAll('.rv-gallery__thumb');
      var counter = gal.querySelector('.rv-gallery__counter');
      var cur = 0;
      function goTo(n) {
        slides[cur].dataset.active = 'false';
        if (thumbs[cur]) thumbs[cur].dataset.active = 'false';
        cur = (n + slides.length) % slides.length;
        slides[cur].dataset.active = 'true';
        if (thumbs[cur]) thumbs[cur].dataset.active = 'true';
        if (counter) counter.textContent = (cur + 1) + ' / ' + slides.length;
      }
      var prev = gal.querySelector('.rv-gallery__arrow--prev');
      var next = gal.querySelector('.rv-gallery__arrow--next');
      if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
      if (next) next.addEventListener('click', function () { goTo(cur + 1); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    });
  }

  function initVariants() {
    document.querySelectorAll('.rv-variant-option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var group = opt.closest('.rv-buybox__options');
        if (group) group.querySelectorAll('.rv-variant-option').forEach(function (o) { o.dataset.active = 'false'; });
        opt.dataset.active = 'true';
        var input = document.getElementById('rv-variant-id');
        if (opt.dataset.variantId && input) input.value = opt.dataset.variantId;
        var p1 = document.getElementById('rv-current-price'), p2 = document.getElementById('rv-atc-price');
        if (opt.dataset.priceFormatted) { if (p1) p1.textContent = opt.dataset.priceFormatted; if (p2) p2.textContent = opt.dataset.priceFormatted; }
      });
    });
  }

  function initAnnouncement() {
    var bar = document.querySelector('[data-rv-announcement]');
    if (!bar) return;
    var msgs = bar.querySelectorAll('[data-msg]');
    if (msgs.length < 2) return;
    var i = 0;
    msgs.forEach(function (m, idx) { m.style.opacity = idx === 0 ? '1' : '0'; });
    setInterval(function () { msgs[i].style.opacity = '0'; i = (i + 1) % msgs.length; msgs[i].style.opacity = '1'; }, 3500);
  }

  /* ======================================================
     DISCOUNT AUTO-APPLY — updated to SAVE20 / SAVE30
  ====================================================== */
  function getDiscountCode(cart) {
    var eligibleQty = 0;
    cart.items.forEach(function(it) {
      if (!it.properties || !it.properties._free_gift) eligibleQty += it.quantity;
    });
    if (eligibleQty >= 3) return 'SAVE30';
    if (eligibleQty >= 2) return 'SAVE20';
    return null;
  }

  function updateCheckoutBtn(cart) {
    var btn = document.querySelector('[data-rv-checkout-btn]');
    var notice = document.querySelector('[data-rv-discount-notice]');
    var msg = document.querySelector('[data-rv-discount-msg]');
    if (!btn) return;
    var code = getDiscountCode(cart);
    if (code) {
      btn.href = '/checkout?discount=' + code;
      if (notice) notice.style.display = 'flex';
      if (msg) msg.textContent = code === 'SAVE30'
        ? '30% multi-buy discount applied at checkout'
        : '20% multi-buy discount applied at checkout';
    } else {
      btn.href = '/checkout';
      if (notice) notice.style.display = 'none';
    }
  }

  var THRESHOLD = 5000;
  function money(cents) { return '\u00a3' + (cents / 100).toFixed(2); }

  function openDrawer() {
    var d = document.querySelector('[data-rv-drawer]');
    if (d) { d.dataset.open = 'true'; d.setAttribute('aria-hidden','false'); document.body.style.overflow = 'hidden'; }
  }
  function closeDrawer() {
    var d = document.querySelector('[data-rv-drawer]');
    if (d) { d.dataset.open = 'false'; d.setAttribute('aria-hidden','true'); document.body.style.overflow = ''; }
  }

  function getMassagerQty(cart) {
    var qty = 0;
    cart.items.forEach(function(it) {
      var handle = it.product_handle || it.handle || '';
      if (handle === 'rovela-neck-massager' || handle === 'rovela-3-in-1-back-massager') qty += it.quantity;
    });
    return qty;
  }

  function getPeanutQty(cart) {
    var qty = 0;
    cart.items.forEach(function(it) {
      var handle = it.product_handle || it.handle || '';
      if (handle === 'rovela-peanut-ball') qty += it.quantity;
    });
    return qty;
  }

  function updateUpsell(cart) {
    var upsell = document.querySelector('[data-rv-upsell]');
    if (!upsell) return;
    var handles = cart.items.map(function (it) { return it.product_handle || it.handle || ''; });
    var hasBundle = handles.indexOf('rovela-full-recovery-bundle') !== -1;
    var massagerQty = getMassagerQty(cart);
    var peanutQty = getPeanutQty(cart);
    if (massagerQty === 0 || hasBundle) { upsell.style.display = 'none'; return; }
    upsell.style.display = '';
    var offerRow = upsell.querySelector('[data-rv-upsell-offer]');
    var confirmedRow = upsell.querySelector('[data-rv-upsell-confirmed]');
    if (peanutQty >= massagerQty) {
      if (offerRow) offerRow.style.display = 'none';
      if (confirmedRow) {
        confirmedRow.style.display = '';
        var t = confirmedRow.querySelector('[data-rv-confirmed-title]');
        if (t) t.textContent = massagerQty > 1 ? massagerQty + ' free Peanut Balls added!' : 'Free Peanut Ball added!';
      }
    } else {
      var needed = massagerQty - peanutQty;
      if (offerRow) {
        offerRow.style.display = '';
        var freeTitle = offerRow.querySelector('[data-rv-free-title]');
        var freeSub = offerRow.querySelector('[data-rv-free-sub]');
        var addBtn = offerRow.querySelector('[data-rv-free-add]');
        if (freeTitle) freeTitle.textContent = needed > 1 ? needed + ' x Free Peanut Balls' : 'Free Peanut Ball';
        if (freeSub) freeSub.textContent = needed > 1 ? 'One free with each massager \u2014 today only' : 'Free with your massager \u2014 today only';
        if (addBtn) { addBtn.dataset.qty = needed; addBtn.textContent = needed > 1 ? 'Add ' + needed + ' Free' : 'Add Free'; addBtn.disabled = false; }
      }
      if (confirmedRow) confirmedRow.style.display = 'none';
    }
  }

  function renderCart(cart) {
    var count = cart.item_count;
    document.querySelectorAll('[data-rv-drawer-count]').forEach(function (el) { el.textContent = '\u00b7 ' + count + ' item' + (count !== 1 ? 's' : ''); });
    document.querySelectorAll('[data-rv-cart-count], .rv-header__cart-count').forEach(function (el) { el.textContent = count; });
    var sub = document.querySelector('[data-rv-drawer-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
    var fill = document.querySelector('[data-rv-ship-fill]');
    var msg = document.querySelector('[data-rv-ship-msg]');
    if (fill) fill.style.width = Math.min(100, Math.round(cart.total_price / THRESHOLD * 100)) + '%';
    if (msg) msg.innerHTML = cart.total_price >= THRESHOLD ? '\u2713 You\u2019ve unlocked free UK delivery!' : 'Add <strong>' + money(THRESHOLD - cart.total_price) + '</strong> more for free UK delivery';
    var foot = document.querySelector('[data-rv-drawer-foot]');
    if (foot) { count === 0 ? foot.setAttribute('hidden','') : foot.removeAttribute('hidden'); }
    var body = document.querySelector('[data-rv-drawer-body]');
    if (!body) return;
    body.classList.remove('rv-drawer__loading');
    var emptyEl = body.querySelector('[data-rv-drawer-empty]');
    var wrapEl = body.querySelector('[data-rv-drawer-items]');
    if (count === 0) {
      if (wrapEl) wrapEl.style.display = 'none';
      if (emptyEl) { emptyEl.style.display = ''; }
      else {
        var e = document.createElement('div');
        e.className = 'rv-drawer__empty'; e.setAttribute('data-rv-drawer-empty','');
        e.innerHTML = '<p>Your cart is empty.</p><a href="/collections/all" class="btn-primary" data-rv-drawer-close>Shop the collection</a>';
        body.appendChild(e);
      }
    } else {
      if (emptyEl) emptyEl.style.display = 'none';
      if (!wrapEl) { wrapEl = document.createElement('div'); wrapEl.setAttribute('data-rv-drawer-items',''); body.insertBefore(wrapEl, body.firstChild); }
      wrapEl.style.display = '';
      wrapEl.innerHTML = cart.items.map(function (it) {
        var imgSrc = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2') : '';
        var img = imgSrc ? '<img src="' + imgSrc + '" alt="' + (it.product_title || '') + '">' : '';
        var variant = it.product_has_only_default_variant ? '' : '<div class="rv-drawer__item-variant">' + (it.variant_title || '') + '</div>';
        return ['<div class="rv-drawer__item" data-key="',it.key,'">','<a href="',it.url,'" class="rv-drawer__item-img">',img,'</a>','<div class="rv-drawer__item-info">','<div class="rv-drawer__item-title">',it.product_title,'</div>',variant,'<div class="rv-drawer__item-qty">','<button class="rv-qbtn" data-rv-qty-down data-key="',it.key,'">'+'\u2212'+'</button>','<span data-rv-qty>',it.quantity,'</span>','<button class="rv-qbtn" data-rv-qty-up data-key="',it.key,'">+</button>','<button class="rv-drawer__item-remove" data-rv-remove data-key="',it.key,'">Remove</button>','</div>','</div>','<div class="rv-drawer__item-price">',money(it.final_line_price),'</div>','</div>'].join('');
      }).join('');
    }
    updateUpsell(cart);
    updateCheckoutBtn(cart);
  }

  window.rovelaRenderCart = renderCart;

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeLine(key, qty) {
    var body = document.querySelector('[data-rv-drawer-body]');
    if (body) body.classList.add('rv-drawer__loading');
    return fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(variantId, qty, properties) {
    var payload = { items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] };
    if (properties) payload.items[0].properties = properties;
    return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(payload) })
    .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error(d.description||'Failed'); }); return fetchCart(); })
    .then(function (cart) { renderCart(cart); openDrawer(); return cart; });
  }

  function initDrawer() {
    var drawer = document.querySelector('[data-rv-drawer]');
    if (!drawer) return;
    document.querySelectorAll('[data-rv-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); fetchCart().then(renderCart); openDrawer(); });
    });
    document.addEventListener('click', function (e) { if (e.target.closest('[data-rv-drawer-close]')) { e.preventDefault(); closeDrawer(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    document.addEventListener('rv:cart:updated', function(e) { renderCart(e.detail); openDrawer(); });
    drawer.addEventListener('click', function (e) {
      var up = e.target.closest('[data-rv-qty-up]');
      var down = e.target.closest('[data-rv-qty-down]');
      var rm = e.target.closest('[data-rv-remove]');
      var add = e.target.closest('[data-rv-add]');
      if (up) { changeLine(up.dataset.key, parseInt(up.parentNode.querySelector('[data-rv-qty]').textContent,10) + 1); }
      else if (down) { changeLine(down.dataset.key, Math.max(0, parseInt(down.parentNode.querySelector('[data-rv-qty]').textContent,10) - 1)); }
      else if (rm) { changeLine(rm.dataset.key, 0); }
      else if (add) {
        var qty = parseInt(add.dataset.qty || '1', 10);
        var origText = add.textContent;
        add.textContent = 'Adding\u2026'; add.disabled = true;
        addToCart(add.dataset.variant, qty, add.hasAttribute('data-rv-free-add') ? { _free_gift: 'true' } : null)
          .catch(function () { add.textContent = origText; add.disabled = false; });
      }
    });
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      if (form.closest('[data-rv-qty-selector]')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var orig = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
      var fd = new FormData(form);
      fetch('/cart/add.js', { method:'POST', body:fd, headers:{'Accept':'application/json'} })
        .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error(d.description||'Error'); }); return fetchCart(); })
        .then(function (cart) { renderCart(cart); openDrawer(); if (btn) { btn.disabled=false; btn.innerHTML=orig; } })
        .catch(function (err) { console.error('ATC:',err); if (btn) { btn.disabled=false; btn.innerHTML=orig; } });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFaq(); initSpecsTabs(); initStickyBar(); initGallery(); initVariants(); initAnnouncement(); initDrawer();
  });

})();
